import { numberToPrettyString } from '@cian/utils';

import { isCommercialLand } from './isCommercialLand';
import { isCommercialMultiAds } from './multiAds/isCommercialMultiAds';
import { IOffer } from '../../../types/offer';

export function getCommercialPerMeterByYear(offer: IOffer): string | undefined {
  // Для мультиобъявления показываем минимальную цену за м² среди частей с приставкой «от»
  if (isCommercialMultiAds(offer) && offer.minPricePerMeterPerYearRur) {
    return `от ${numberToPrettyString(Math.round(offer.minPricePerMeterPerYearRur))} ₽/м² в год`;
  }

  if (!offer.pricePerUnitAreaPerYearRur) {
    return undefined;
  }

  let unit = 'м²';

  if (isCommercialLand(offer)) {
    unit = offer.land?.areaUnitType === 'hectare' ? 'га' : 'сот.';
  }

  return `${numberToPrettyString(offer.pricePerUnitAreaPerYearRur)} ₽/${unit} в год`;
}
